import { render, staticRenderFns } from "./ForgottenPinSection.vue?vue&type=template&id=5db2f459&"
import script from "./ForgottenPinSection.vue?vue&type=script&lang=js&"
export * from "./ForgottenPinSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports